import { render, staticRenderFns } from "./CandidatesList.vue?vue&type=template&id=2280f376&scoped=true"
import script from "./candidatesList.ts?vue&type=script&lang=ts&external"
export * from "./candidatesList.ts?vue&type=script&lang=ts&external"
import style0 from "./CandidatesList.vue?vue&type=style&index=0&id=2280f376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2280f376",
  null
  
)

export default component.exports